import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "open": _vm.syncDialogOpen,
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.syncChangesToDevices', {
        n: Math.max(0, _vm.linkedDevicesTotalCount)
      }),
      "buttons": _vm.promptButtons
    },
    on: {
      "saveAndSynchronise": _vm.saveAndSynchronise,
      "cancel": function ($event) {
        _vm.syncDialogOpen = false;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.youHaveUnsavedChanges')) + "\n    "), _c('br'), _c('br'), _vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.syncDoneByBackgroundJob')) + "\n  ")]), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.linkedDevicesTotalCount === 0 ? _c('core-n20Card', [_c('core-empty-state', {
    attrs: {
      "icon": "fa-external-link",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.noLinkedVirtualDevices')) + "\n          ")];
      },
      proxy: true
    }], null, false, 3369122504)
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.noLinkedVirtualDevicesDescription')) + "\n          ")])])], 1) : _vm._e(), _vm.allDevicesSynced ? _c('core-n20Card', [_c('core-empty-state', {
    attrs: {
      "icon": "fa-check",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.noChangesSinceLastSync')) + "\n          ")];
      },
      proxy: true
    }], null, false, 2370798153)
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.noChangesSinceLastSyncDescription')) + "\n          ")])])], 1) : _vm._e()], 1), _vm.showUnsyncedSection ? _c(VCardText, [_c(VDataTable, {
    attrs: {
      "headers": _vm.tableLocalizations.headers,
      "items": _vm.unsyncedChangeRows,
      "loading": _vm.tableLoading,
      "color": _vm.color,
      "expanded": _vm.expanded,
      "item-key": "_rowKey",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    }
  }), _vm.linkedDevicesTotalCount !== 0 ? _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('core-button', {
    attrs: {
      "dense": "",
      "color": _vm.color,
      "disabled": _vm.syncDisabled,
      "tooltip": _vm.syncDisabled ? _vm.syncDisabledReason : '',
      "data-cy": "sync_changes"
    },
    on: {
      "click": function ($event) {
        _vm.syncDialogOpen = true;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('DigitalTwin.VirtualDevice.deviceTemplates.syncChangesToRelatedDevices')) + "\n        ")])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };